import { render, staticRenderFns } from "./Manual.vue?vue&type=template&id=4fcbae3b&scoped=true"
import script from "./Manual.vue?vue&type=script&lang=js"
export * from "./Manual.vue?vue&type=script&lang=js"
import style0 from "./Manual.vue?vue&type=style&index=0&id=4fcbae3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcbae3b",
  null
  
)

export default component.exports